import aiStrategy from "../../../docs/duda-copy/services--ai-strategy.txt?raw"
import design from "../../../docs/duda-copy/services--design.txt?raw"
import product from "../../../docs/duda-copy/services--product.txt?raw"
import sprintZero from "../../../docs/duda-copy/services--sprint-zero.txt?raw"
import services from "../../../docs/duda-copy/services.txt?raw"
import accelerators from "../../../docs/duda-copy/solutions--accelerators.txt?raw"
import earlyStartups from "../../../docs/duda-copy/solutions--early-startups.txt?raw"
import growthStartups from "../../../docs/duda-copy/solutions--growth-startups.txt?raw"
import privateEquity from "../../../docs/duda-copy/solutions--private-equity.txt?raw"
import smallMediumBusinesses from "../../../docs/duda-copy/solutions--small-medium-businesses.txt?raw"
import solutions from "../../../docs/duda-copy/solutions.txt?raw"
import webDevelopment from "../../../docs/duda-copy/web-development.txt?raw"

export const dudaCopy = {
  services,
  "ai-strategy": aiStrategy,
  "web-development": webDevelopment,
  design,
  product,
  "sprint-zero": sprintZero,
  solutions,
  "early-startups": earlyStartups,
  "growth-startups": growthStartups,
  "small-medium-businesses": smallMediumBusinesses,
  "private-equity": privateEquity,
  accelerators,
} as const

export type DudaCopyPageId = keyof typeof dudaCopy
